export type PresetsButtonsProps = {
  currentValue: Nullable<number>;
  valuePresets: number[];
  isDisabled?: boolean;
  onClick: (value: number) => void;
};

export function PresetsButtons({ currentValue, valuePresets, onClick, isDisabled }: PresetsButtonsProps) {
  if (!valuePresets || valuePresets.length === 0) {
    return null;
  }

  return (
    <div className="input-icon-end w-auto align-items-start">
      <div className="d-flex gap-2 pe-3">
        {valuePresets.map(preset => (
          <button
            key={preset}
            className={`btn btn-link px-0 text-decoration-underline${currentValue === preset ? ' active' : ''}`}
            onClick={() => onClick(preset)}
            disabled={isDisabled}
          >
            {preset}
          </button>
        ))}
      </div>
    </div>
  );
}
